<template>
<div>
    <div class="desktop container header-foot-menu">
        <ul class="header-menu-list">
            <li class="list" @mouseover="menu.isHovered = true" @mouseleave="menu.isHovered = false" v-for="(menu, index) in menus" :key="index">
                <router-link :to="{ path: menu.url}"> {{menu.title}} </router-link>
                <font-awesome-icon v-if="menu.isCaret" :icon="hoverHandler(menu)" />
                <ul class="dropdown dropdown-list" v-if="menu.showmenu">
                    <li @click="showSubMenu(list)" v-for="(list, index) in menu.list" :key="index">
                        <a :href="list.url">{{list.title}}</a>
                        <font-awesome-icon v-if="list.isCaret" class="faicon" :icon="['fas', 'chevron-right']" />
                        <ul class="sub-menu" v-if="list.showsubmenu">
                            <li v-for="(list, index) in list.submenuList" :key="index">
                                <a :href="list.url">{{list.title}}</a>
                            </li>

                        </ul>
                    </li>

                </ul>
            </li>

        </ul>
    </div>
    <div class="container mobile header-foot-menu">
        <ul class="header-menu-list">
            <li class="list" v-for="(menu, index) in menus" :key="index">
                <router-link @click="menu.isHovered = true" :to="{ path: menu.url}"> {{menu.title}} </router-link>
                <ul class="dropdown dropdown-list" v-if="menu.showmenu">
                    <li @click="showSubMenu(list)" v-for="(list, index) in menu.list" :key="index">
                        <a :href="list.url">{{list.title}}</a>
                        <ul class="sub-menu" v-if="list.showsubmenu">
                            <li v-for="(list, index) in list.submenuList" :key="index">
                                <a :href="list.url">{{list.title}}</a>
                            </li>

                        </ul>
                    </li>

                </ul>
            </li>

        </ul>
    </div>
</div>
</template>

<script>
export default {
    name: 'body-links',
    data: function () {
        return {
            menus: [{
                    title: 'RECIPE',
                    url: '#',
                    isCaret: true,
                    showmenu: true,
                    isHovered: false,
                    list: [{
                            title: 'All Recipes',
                            showsubmenu: false,
                            url: '/recipes',
                            isCaret: false,
                        },
                        {
                            title: 'Create Recipe',
                            showsubmenu: false,
                            isCaret: false,
                            url: '/recipes/create',
                        }
                    ]
                },
                {
                    title: 'LANGUAGE',
                    url: '/languages',
                    isCaret: false,
                    showmenu: false
                },
                {
                    title: 'EVENT',
                    isCaret: true,
                    isHovered: false,
                    url: '#',
                    showmenu: true,
                    list: [{
                            title: 'All Events',
                            showsubmenu: false,
                            url: '/listings/events',
                            isCaret: false,
                        },
                        {
                            title: 'Create event ',
                            showsubmenu: false,
                            url: '/listings/events/create',
                            isCaret: false,
                        }
                    ]
                },
                {
                    title: 'STORES',
                    url: '#',
                    isCaret: true,
                    showmenu: true,
                    isHovered: false,
                    list: [{
                            title: 'Vendors',
                            showmenu: false,
                            url: 'https://stores.culturesquare.com/become-a-vendor/',
                            isCaret: false,
                        },
                        {
                            title: 'Buy Products ',
                            showmenu: false,
                            url: 'https://stores.culturesquare.com',
                            isCaret: false,
                        },
                        {
                            title: 'List Services ',
                            showmenu: false,
                            url: '/services',
                            isCaret: false,
                        },
                    ]
                },
            ],
        }
    },
    computed: {
        cart: function () {
            return this.$store.getters.cart;
        }
    },
    methods: {
        showSubMenu(list) {
            if (list.isCaret == true) {
                list.showsubmenu = !list.showsubmenu
            } else {
                list.showsubmenu = false
            }

        },
        hoverHandler(menu) {
            if (menu.isHovered === true) {
                return "chevron-down"
            } else {
                return "chevron-right"
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.svg-inline--fa {
    height: 0.7em !important
}

.list a {
    color: #565C63;

    @media screen and (min-device-width: 340px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        font-size: 13px
    }
}

.header-foot-menu {
    height: 68px;
    display: flex;
    justify-content: center;
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #ccc;

    @media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
        margin-top: 5px;
        height: 48px;
    }

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        height: 40px;
        justify-items: center;
        align-items: center;
        margin-top: -1rem;

    }
}

.header-menu-list {
    margin: 0 !important;
    display: flex;
    justify-content: center;
    position: relative;

}

.header-menu-list li {
    padding: 24px 40px;

    @media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
        padding: 3px;
        font-size: 11px
    }

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        padding: 4px;

    }

    @media screen and (min-device-width: 712px) and (max-device-width: 1200px) and (-webkit-min-device-pixel-ratio: 1) {
        padding: 20px;

    }
}

.food-drop {
    display: none
}

li:hover {
    cursor: pointer;
}

.dropdown {
    position: absolute;
    width: 150px;
    background-color: #565C63;
    -webkit-transition: all 0.3s ease-out 0s;
    -o-transition: all 0.3s ease-out 0s;
    transition: all 0.3s ease-out 0s;
    padding: 4px 10px 10px !important;
    top: 68px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        top: 39px;
        width: 170px;

    }
}

.sub-menu {
    position: absolute;
    width: 200px;
    background-color: #565C63;
    -webkit-transition: all 0.3s ease-out 0s;
    -o-transition: all 0.3s ease-out 0s;
    transition: all 0.3s ease-out 0s;
    padding: 4px 10px 10px !important;
    top: -4px;
    left: 140px;
}

.dropdown-list {
    display: none;
    z-index: 99;
}

li.list:hover .dropdown-list {
    display: block;
    -webkit-transition: all 0.3s ease-out 0s;
    -o-transition: all 0.3s ease-out 0s;
    transition: all 0.3s ease-out 0s;
    box-shadow: 0 2px 8px 0 rgb(0 29 35 / 5%);
    -webkit-box-shadow: 0 2px 8px 0 rgb(0 29 35 / 5%);
}

.dropdown li {
    line-height: 1;
    margin: 0;
    padding: 0px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative
}

.dropdown li a:hover {
    color: #fff;

}

.dropdown li a {
    display: block;
    padding: 15px 7px
}

.dropdown li a,
.sub-menu li,
.faicon {
    color: rgba(255, 255, 255, 0.54);
    font-size: 12px;

}

@media screen and (min-device-width: 340px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
    .svg-inline--fa {
        font-size: 12px
    }
}
</style>
